import { cn } from '@/utils'
import { ACTIVITY_GROUP_OF, ACTIVITY_TYPE_LABELS } from '../model/activityView'
import type { ActivityGroup, ActivityType } from '../model/types'

interface TypeChipsProps {
  group: ActivityGroup | 'all'
  typeCounts: Partial<Record<ActivityType, number>>
  chosen: ActivityType[]
  onToggle: (type: ActivityType) => void
}

// With a group on, its member types show as chips with counts, so the reader can narrow further.
export const TypeChips = ({
  group,
  typeCounts,
  chosen,
  onToggle,
}: TypeChipsProps) => {
  if (group === 'all') return null
  const types = (Object.keys(typeCounts) as ActivityType[]).filter(
    (type) => ACTIVITY_GROUP_OF[type] === group,
  )
  if (types.length < 2) return null
  return (
    <div className="mt-3 flex flex-wrap items-center gap-2">
      <span className="mr-1 text-xs text-ink-subtle">Types</span>
      {types.map((type) => {
        const isOn = chosen.length === 0 || chosen.includes(type)
        return (
          <button
            key={type}
            type="button"
            aria-pressed={isOn}
            onClick={() => onToggle(type)}
            className={cn(
              'inline-flex cursor-pointer items-center gap-1.5 rounded-md border px-2 py-1 text-xs font-medium',
              isOn
                ? 'border-blue-4 bg-blue-2 text-blue-7'
                : 'border-border bg-white text-blue-5',
            )}
          >
            {ACTIVITY_TYPE_LABELS[type]}{' '}
            {(typeCounts[type] ?? 0).toLocaleString('en-US')}
          </button>
        )
      })}
    </div>
  )
}
